import sum from "./sum";
import calc from "./calc";
import disableIf from "./disableIf";
import openWindowPopover from "./open-window-popover";
import disableAllInputs from "./disable-all-inputs";
export default Vue => {
  Vue.directive("sum", sum);
  Vue.directive("calc", calc);
  Vue.directive("disableIf", disableIf);
  Vue.directive("open-window-popover", openWindowPopover);
  Vue.directive("disable-all-inputs", disableAllInputs);
};